// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLineCardExpandedStyles } from "@bg/Overrides/Widgets/Cart/CartLineCardExpanded";
import { quickOrderProductListStyles } from "@bg/Overrides/Widgets/QuickOrder/QuickOrderProductList";
import { productQuantityOrderedStyles } from "@bgs/Overrides/Components/ProductQuantityOrdered";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

quickOrderProductListStyles.productQty = {
    wrapper: {
        css: css`
            ${productQuantityOrderedStyles.wrapper?.css}
            min-height: 36px;
            max-width: 1258px;
            button:last-child {
                border-right: 2px solid ${getColor("text")} !important;
            }
            height: 100%;
        `,
    },
    inputStyles: {
        cssOverrides: {
            formInputWrapper: css`
                &&&&&&& {
                    margin-top: 0;
                    max-width: 110px;
                    height: 100% !important;
                    min-height: 32px;
                }
            `,
            inputSelect: css`
                max-width: 100% !important;
                width: 100% !important;
                text-align: center !important;
                min-height: 32px;
                height: 100% !important;
            `,
        },
    },
};

cartLineCardExpandedStyles.removeCartLineIcon = {
    src: "Delete",
    size: 16,
    color: "tertiary.main",
    css: css`
        &:hover,
        &:focus {
            svg g {
                color: ${getColor("tertiary.main")};
            }
        }
    `,
};
